import { inject, Injectable } from "@angular/core";
import { parseToProjectHeader, ProjectHeader, ProjectHeaderDto } from "../types/project-header.type";
import { Observable } from "rxjs/internal/Observable";
import { HttpClient, HttpParams } from "@angular/common/http";
import { buildProjectPayloadChunkParam, PROJECT_PAYLOAD_CHUNKS } from "@features/project/types/project-payload-chunks.types";
import { map } from "rxjs/internal/operators/map";
import { Subject } from "rxjs";

const BASE_URL: string = "/api/projects";

@Injectable({
  providedIn: "root"
})
export class ProjectHeaderService {
  private readonly _httpClient: HttpClient = inject(HttpClient);

  private readonly _reload$: Subject<void> = new Subject<void>();

  public readonly reload$: Observable<void> = this._reload$.asObservable();

  public getProjectHeader (projectNumber: string): Observable<ProjectHeader> {
    const params: HttpParams = buildProjectPayloadChunkParam(PROJECT_PAYLOAD_CHUNKS.minimal);

    return this._httpClient.get<ProjectHeaderDto>(`${ BASE_URL }/${ projectNumber }`, { params })
      .pipe(
        map(parseToProjectHeader)
      );
  }

  public reload (): void {
    this._reload$.next();
  }
}
